import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { useTranslate } from 'react-admin';

import { DeviationMainCategory } from '../../../entities/DeviationMainCategory';

export const CategoryFilterField = ({ value, onChange }) => {
	const translate = useTranslate();
	
	const handleChange = (e) => {
		onChange && onChange(e.target.value === "" ? undefined : e.target.value);
	};

	const categories = Object.entries(DeviationMainCategory).map(([key, id]) => ({
		id,
		name: translate(`osfc.enums.deviation_main_category.${key}`)
	}));

	return (
		<TextField
			select
			label={translate("resources.deviations.export-dialog.fields.category")}
			variant="outlined"
			margin="none"
			size="small"
			value={value !== undefined ? value : ""}
			onChange={handleChange}
			style={{ width: 200, marginLeft: 8 }}
		>
			<MenuItem value="">All</MenuItem>
			{categories.map(category => (
				<MenuItem key={category.id} value={category.id}>
					{category.name}
				</MenuItem>
			))}
		</TextField>
	);
};